import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {getPriceWithCurrency} from "../../../misc/helpers";
import ContractsPopupFieldsFinance from "./contractsPopupFieldsFinance";
import {getCostcoContractField, isCostcoContractField} from "../../../misc/otherPricingLogic/costcoFunctions";

const getFieldDiv = (value, field, fieldCoords) => {
  if (!value && value !== 0 && value !== "0") {
    return null
  }
  return (
    <div
      data-name={field.name}
      className={'contract-body__value'}
      style={fieldCoords}>
      {value}
    </div>
  )
}

const ContractsPopupFieldValue = (props) => {

  const {field, fieldCoords, userState, fabricatorData, assignQuotePopupEmployee, grandTotal, depositValue, intl,
    financeActiveDiscount, paymentState} = props;
  const {userInfo} = userState;
  const fabricatorSettings = fabricatorData.settings;

  if (!field.name) {
    return null
  } else if (isCostcoContractField(field)) {
    return getFieldDiv(getCostcoContractField(field.name), field, fieldCoords)
  }

  switch (field.name) {
    case "firstName":
    case "lastName":
    case "email":
      return getFieldDiv(userInfo[field.name], field, fieldCoords);
    case "customerFullAddress":
      return paymentState.shippingAddress && paymentState.shippingAddress.address1
        ? getFieldDiv(paymentState.shippingAddress.address1, field, fieldCoords)
        : getFieldDiv(userInfo["address1"], field, fieldCoords)
    case "zipCode":
      return paymentState.shippingAddress && (paymentState.shippingAddress.postal || paymentState.shippingAddress.zip)
        ? getFieldDiv(paymentState.shippingAddress.postal || paymentState.shippingAddress.zip, field, fieldCoords)
        : getFieldDiv(userInfo["postal"], field, fieldCoords);
    case "phone": {
      const fullNumber = (userInfo.country && userInfo.country.dialCode)
        ? `+${userInfo.country.dialCode} ${userInfo.phoneNumber}`
        : userInfo["phoneNumber"]
      return getFieldDiv(fullNumber, field, fieldCoords);
    }
    case "jobId":
      return getFieldDiv(document.kvConfig.jobId, field, fieldCoords);
    case "salesPerson": {
      let employeeSelected = null;
      if (userInfo.employeeId && userState.employeesListReceived) {
        employeeSelected = userState.employeesList.find(emp => +emp.id === +userInfo.employeeId)
      } else {
        employeeSelected = assignQuotePopupEmployee;
      }
      return getFieldDiv(employeeSelected ? employeeSelected.fullName : "", field, fieldCoords);
    }
    case "signatureDate":
      // return getFieldDiv(moment().format('MM/DD/YYYY h:mma'));
      return getFieldDiv(moment().format('MM/DD/YYYY'), field, fieldCoords);
    case "price": {
      const withCurrency = getPriceWithCurrency(fabricatorSettings, grandTotal.toFixed(2));
      return getFieldDiv(withCurrency, field, fieldCoords)
    }
    case "deposit": {
      return getFieldDiv(getPriceWithCurrency(fabricatorSettings, depositValue.toFixed(2)), field, fieldCoords);
    }
    case "balance": {
      const balance = (grandTotal - depositValue).toFixed(2);
      const withCurrency = getPriceWithCurrency(fabricatorSettings, balance);
      return getFieldDiv(withCurrency, field, fieldCoords)
    }
    case "financePlan": {
      return financeActiveDiscount ? getFieldDiv(financeActiveDiscount.financePlan, field, fieldCoords) : null
    }
    case "financeTerm": {
      return financeActiveDiscount ? getFieldDiv(financeActiveDiscount.financeMonths + " " + intl.formatMessage({id: "shoppingCart.discounts.months"}), field, fieldCoords) : null
    }
    case "financePercentage": {
      return financeActiveDiscount ? getFieldDiv(financeActiveDiscount.financePercentage + "%", field, fieldCoords) : null
    }
    case "financeCompany": {
      return financeActiveDiscount ? getFieldDiv(financeActiveDiscount.financeCompany, field, fieldCoords) : null
    }
    // case "balanceDue":
    //   return getFieldDiv(contractsValues?.[activeContract.id]?.[coord.page]?.[coord.fieldIndexOnPage]?.value)
    case "financeAmount":
    case "financedAmount":
      return financeActiveDiscount ? getFieldDiv(<ContractsPopupFieldsFinance {...props}/>, field, fieldCoords) : null
    case "balanceDue":
      return getFieldDiv(<ContractsPopupFieldsFinance {...props}/>, field, fieldCoords)
    case "checkAch":
    case "creditCard":
    case "custom":
    case "checkbox":
    case "signature":
    default:
      return null
  }
};

// ["costcoExclusiveMembers"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Executive Members") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",
//   ["costcoShopCard"] = costcoShopCard.ToString("0.00"),
//   ["costcoCitiVisa"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Citi Visa Cardholder") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",

ContractsPopupFieldValue.propTypes = {
  field: PropTypes.object,
  fieldCoords: PropTypes.object,
  totalPrice: PropTypes.object,
}

const mapStateToProps = (store) => {
  const userState = store.userState;
  const {assignQuotePopupEmployee} = store.assignQuoteState;
  const {financeActiveDiscount, discountSections} = store.priceWorksheetState;

  return {
    assignQuotePopupEmployee,
    userState,
    financeActiveDiscount,
    paymentState: store.paymentState,
    discountSections,
    fabricatorData: store.fabricatorState,
  };
};

export default injectIntl(
  connect(mapStateToProps)(ContractsPopupFieldValue)
)
